import React from "react";
import { Box, Typography } from "@mui/material";
import { keyframes } from "@emotion/react";

const typingBounce = keyframes`
  0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
  30% { transform: translateY(-4px); opacity: 1; }
`;

const TypingIndicator = ({ who = "Someone" }) => {
  return (
    <Box 
      sx={{ 
        display: 'inline-flex', 
        alignItems: 'center', 
        gap: '4px', 
        padding: '8px 14px', 
        borderRadius: '18px', 
        background: 'rgba(248,250,253,0.95)',
        boxShadow: 'inset 0 0 0 1px rgba(148,163,184,0.14)',
        animation: 'fadeIn 0.3s ease'
      }}
      aria-live="polite"
    >
      {[0, 1, 2].map((i) => (
        <Box
          key={i}
          sx={{
            width: '6px',
            height: '6px',
            background: '#60A5FA',
            borderRadius: '50%',
            animation: `${typingBounce} 1.4s infinite ease-in-out`,
            animationDelay: `${i * 0.2}s`
          }}
        />
      ))}
      <Typography 
        sx={{ 
          fontSize: '12px', 
          fontWeight: 500, 
          color: '#64748B', 
          marginLeft: '6px',
          fontFamily: "'Plus Jakarta Sans', 'Inter', sans-serif"
        }}
      >
        {who} is typing…
      </Typography>
    </Box>
  );
};

export default TypingIndicator;

